import React from 'react'
import {Container} from 'react-bootstrap'

const Footer = () => {
  return (
    <Container fluid className='mb-auto' style={{backgroundColor: '#92a8d1', height: '6em'}}>
    </Container>
  )
}

export default Footer